import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const faqs = [
  {
    question: "What is QE Navigator?",
    answer: "QE Navigator is a quality engineering intelligence platform. It unifies data from your existing tools—Jenkins, Jira, SonarQube, TestRail, Rally and more—into one dashboard: deep technical metrics for engineers, and clear business impact for executives. Same data, both languages."
  },
  {
    question: "Which tools does it integrate with?",
    answer: "Jenkins, Jira, SonarQube, GitHub, GitLab, Azure DevOps, CircleCI, TestRail, Rally, Selenium Grid, Grafana, Datadog, New Relic—and custom tools on request. Just tell us your stack and we configure the integrations for you. No code changes required."
  },
  {
    question: "How is this different from other engineering-metrics tools?",
    answer: "The business impact correlation. Most tools show engineering metrics; QE Navigator maps them to revenue, so leadership can finally answer \"Which bugs impact revenue?\" and \"What's our real QA ROI?\" It's built by a Quality Engineer with 15 years in Payments, FinTech, and Healthcare—every feature solves a problem I lived firsthand."
  },
  {
    question: "How do we get started?",
    answer: "Request a demo and we'll walk you through the platform with a live environment. If it's a fit, we connect your tools and tailor the dashboards to your stack—so you're seeing your own metrics quickly, not a lengthy build project."
  },
  {
    question: "Do you also offer hands-on consultancy?",
    answer: "Yes. Beyond the platform, I offer QA strategy, CI/CD and test-automation optimization, flaky-test remediation, and metrics-to-business alignment—drawing on 15 years across mission-critical industries. Many teams start with a consultancy engagement and adopt QE Navigator as part of it."
  }
];

function FAQItem({ question, answer, isOpen, onClick }) {
  return (
    <div className="border border-accent/20 rounded-lg overflow-hidden mb-4 transition-all duration-300 hover:border-accent/40">
      <button
        className="w-full px-6 py-4 text-left flex justify-between items-center bg-secondary/50 hover:bg-secondary transition-colors"
        onClick={onClick}
      >
        <span className="text-lg font-medium text-text-primary">{question}</span>
        {isOpen ? (
          <ChevronUp className="w-5 h-5 text-accent flex-shrink-0" />
        ) : (
          <ChevronDown className="w-5 h-5 text-accent flex-shrink-0" />
        )}
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
          }`}
      >
        <div className="px-6 py-4 bg-secondary/30">
          <p className="text-text-secondary leading-relaxed">{answer}</p>
        </div>
      </div>
    </div>
  );
}

function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const handleClick = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 relative">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-text-primary mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-text-secondary text-lg max-w-2xl mx-auto">
            Common questions about QE Navigator and our consultancy
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, index) => (
            <FAQItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={openIndex === index}
              onClick={() => handleClick(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default FAQ;
